import React, {useContext, useEffect, useState} from 'react';
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import { UserContext } from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import AchievementStar, {STAR} from "../progress/student/AchievementStar";

const StudentRecentProgressDashboardWidgetUSA = ({ smallScreenMode }) => {
    const [recentConceptScores, setRecentConceptScores] = useState();
    const [isLoading, setLoading] = useState(true);
    const { user } = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();

    const loadRecentConceptScores = () => {
        setLoading(true);
        if(user){
            axios.get(`/web/ui/content/userConceptScores/recent?syllabusId=${user.syllabusId}`)
                .then(response => {
                    if(response.data){
                        setRecentConceptScores(response.data.reverse().slice(0, 4));
                    }
                    setLoading(false);
                });
        }
    }

    useEffect(() => {
        loadRecentConceptScores();
    }, []);


    return (
        <div className={'ch-dashboard-usa-progress'}>
            <h2>See your recent progress</h2>
            <div>
                {recentConceptScores && recentConceptScores.length > 0 ?
                    <>
                    <div className={'ch-dashboard-usa-progress-cards-wrapper'}>
                        <div className={'ch-dashboard-usa-progress-cards'} tabIndex={-1}>
                            {recentConceptScores.map(recentConcept => {
                                return (
                                    <USAProgressCard
                                        recentConcept={recentConcept}
                                        key={recentConcept.lastPracticeQuestionDate}
                                        smallScreenMode={smallScreenMode}
                                    />
                                );
                            })}
                        </div>
                    </div>
                    <button className={'genBtn'}
                            onClick={() => loadShortcutByUrl("/web/ui/view/studentAchievementProgress")}>See more
                        progress
                    </button>
                    </>
                    :
                    <h3>No recent progress. Complete a quiz to see it here.</h3>}
            </div>
        </div>
    )
}

export default StudentRecentProgressDashboardWidgetUSA;


const USAProgressCard = ({ recentConcept = null, smallScreenMode }) => {
    const { conceptName, attemptedLevels, achievedLevels, lastPracticeQuestionDate } = recentConcept;
    const starSize = smallScreenMode ? 24 : 60;

    const getStarStatus = (level, index) => {
        if (!level) return STAR.NOT_ATTEMPTED
        if (achievedLevels[index]) return STAR.ACHIEVED
        return STAR.ATTEMPTED
    }

    const getText = (level, index) => {
        if (!level) return 'Not attempted'
        if (achievedLevels[index]) return 'Achieved'
        return 'Attempted'
    }

    const getAriaText = (level, index) => {
        const levelNames = ['Basic concepts', 'Skills', 'Applications', 'Reasoning'];
        return `${levelNames[index]} questions ${getText(level, index)}`
    }

    return (
        <div
            aria-label={`${conceptName}. ${attemptedLevels.map((_, i) => getAriaText(attemptedLevels[i], i)).join(', ')}`}
            tabIndex={0}
            className={'ch-dashboard-usa-progress-card-wrapper'}
        >
            <div tabIndex={-1} aria-hidden={true}>
                <DashboardWidget
                    title={<div className="ch-dashboard-title"><span>{conceptName}</span></div>}
                >
                    <div className={"ch-dashboard-stars"}>
                        {attemptedLevels.map((level, index) => {
                            return (
                                    <AchievementStar
                                        width={starSize}
                                        height={starSize}
                                        altText={''}
                                        ariaHidden={true}
                                        starFill={getStarStatus(level, index).starFill}
                                        starColor={getStarStatus(level, index).color}
                                        key={`${conceptName}-star${index}`}
                                    />
                            );
                        })}
                    </div>
                </DashboardWidget>
            </div>

            </div>

    );
};
